import { IconButton as MuiIconButton } from '@mui/material';
import type { IconButtonProps } from '@mui/material/IconButton';
import { styled } from '@mui/material/styles';
import Typography from '@mui/material/Typography';
import type { ReactNode } from 'react';

export const IconButton = styled(MuiIconButton)({
  'padding': 0,
  '&:hover': {
    backgroundColor: 'transparent',
  },
});

export const StyledIconButton = styled(IconButton)({
  width: '100%',
  height: '46px',
  display: 'flex',
  alignItems: 'center',
  justifyContent: 'flex-start',
});

export const Text = styled(Typography)(({ theme }) => ({
  fontSize: 14,
  fontWeight: 400,
  lineHeight: '24px',
  color: theme.palette.text.primary,
  marginLeft: 10,
  whiteSpace: 'pre-line',
}));

type IconButtonWithTextProps = IconButtonProps & {
  icon: ReactNode;
  defaultLabel?: string;
};

export const IconButtonWithText = ({
  icon,
  defaultLabel,
  children,
  ...props
}: IconButtonWithTextProps) => {
  return (
    <StyledIconButton {...props}>
      {icon}
      <Text>{children ?? defaultLabel}</Text>
    </StyledIconButton>
  );
};
